import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { ciganoSpreadTypes } from '../data/spreadTypes';

const CiganoPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-mystical theme-bg-background">
      <div className="flex items-center justify-between px-4 sm:px-6 py-5 border-b border-white/10">
        <Link to="/dashboard" className="flex items-center gap-2 text-white/70 hover:text-white transition-colors">
          <ArrowLeft size={20} />
          <span className="text-sm">Voltar</span>
        </Link>
        <h1 className="text-xl font-mystical font-bold text-white">Baralho Cigano</h1>
        <div className="w-20" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-6 sm:py-10">
        <div className="text-center mb-8 sm:mb-10">
          <div className="text-4xl sm:text-5xl mb-3">🍀</div>
          <h2 className="text-xl sm:text-3xl font-mystical font-bold text-white mb-2">Escolha sua Tiragem</h2>
          <p className="text-white/50 text-sm max-w-md mx-auto">
            Leitura direta e sem rodeios — o Lenormand não enrola, vai direto ao que as cartas mostram.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {ciganoSpreadTypes.map(spread => (
            <div
              key={spread.id}
              className="flex flex-col rounded-2xl overflow-hidden transition-all duration-250"
              style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)' }}
            >
              <div className="h-1 w-full" style={{ background: 'linear-gradient(to right,#15803d,#4ade80)' }} />
              <div className="flex flex-col flex-1 p-5">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-12 h-12 rounded-xl flex items-center justify-center text-2xl" style={{ background: 'rgba(74,222,128,0.15)' }}>
                    🍀
                  </div>
                  <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{ background: 'rgba(74,222,128,0.18)', color: '#4ade80' }}>
                    {spread.cardCount} carta{spread.cardCount > 1 ? 's' : ''}
                  </span>
                </div>
                <h3 className="text-white font-semibold text-base mb-1.5 leading-snug">{spread.name}</h3>
                <p className="text-white/45 text-sm leading-relaxed flex-1 mb-5">{spread.description}</p>
                <button
                  onClick={() => navigate(`/consultation?spread=${spread.id}`)}
                  className="w-full py-2.5 rounded-xl text-white text-sm font-semibold transition-opacity duration-200"
                  style={{ background: 'linear-gradient(135deg,#15803d,#22c55e)' }}
                >
                  Iniciar Consulta
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CiganoPage;
